<template>
    <header class="layout-topbar">
        <!-- <button class="p-link layout-menu-button" @click="onMenuToggle">
            <span class="pi pi-bars"></span>
        </button> -->
        <div class="layout-topbar-title">
            <h1>{{ pageTitle }}</h1>
        </div>
        <div class="layout-topbar-icons">
            <!--<button class="p-link" @click="$router.push('/user/financial')">
                <span class="layout-topbar-icon icon-finance"></span>
                <span class="layout-topbar-item-text">Financial Data</span>
            </button>
            <button v-if="$store.state.currentUser.role !== 'customer'" class="p-link" @click="$router.push('/user/kyc')">
                <span class="layout-topbar-icon icon-check"></span>
                <span class="layout-topbar-item-text">KYC Check</span>
            </button>-->
            <button class="p-link" @click="$router.push('/user/profile')">
                <div class="layout-topbar-profile">
                    <div class="layout-topbar-profile-avatar">
                        <span>{{ nameLetter }}</span>
                        <span>{{ surenameLetter }}</span>
                    </div>
                    <div class="layout-topbar-profile-info">
                        <div class="name">{{ userName }} {{ userLastName }}</div>
                        <div class="role">{{ userRole }}</div>
                    </div>
                    <!-- <div v-else class="layout-topbar-profile-info">
                        <div class="name">{{ email }}</div>
                        <div class="role">Company</div>
                    </div> -->
                </div>
            </button>
            <button class="p-link">
                <span title="Logout" class="layout-topbar-icon icon-logout" @click="confirmLogout"></span>
            </button>
        </div>
        <Dialog header="Are you sure?" :visible.sync="confirmDialog" :style="{width: '30vw'}" :modal="true">
            <span>Are you sure you want to log out?</span>
            <template #footer>
                <Button label="Log out" @click="logout()" icon="pi pi-check" class="p-button" />
            </template>
        </Dialog>
    </header>
</template>

<script>
    export default {
        data() {
            return {
                confirmDialog: false,
                pageTitle: this.$store.state.pageTitle
            }
        },
        created() {
            this.email = this.$store.state.currentUser.email;
            this.userName = this.$store.state.currentUser.first_name;
            this.userLastName = this.$store.state.currentUser.last_name;
            this.userRole = this.$store.state.currentUser.role;
            this.nameLetter = this.$store.state.currentUser.name.split('')[0];
            this.surenameLetter = this.$store.state.currentUser.surname.split('')[0];
        },
        watch: {
            '$store.state.pageTitle': function () {
                if (this.pageTitle !== this.$store.state.pageTitle) {
                    this.pageTitle = this.$store.state.pageTitle;
                }
            }
        },
        methods: {
            onMenuToggle(event) {
                this.$emit('menu-toggle', event);
            },
            confirmLogout() {
                this.confirmDialog = true
            },
            logout() {
                this.confirmDialog = false
                this.$store.commit('logOut')
            }
        }
    }
</script>